<div class="rbac-page">
  <div class="rbac-page__header">
    <h4>Roles</h4>
    <button type="button" class="rbac-btn rbac-btn--primary" (click)="openAdd()">+ Add Role</button>
  </div>

  <app-rbac-table
    [columns]="columns"
    [rows]="roles"
    [loading]="loading"
    [showPermission]="true"
    emptyMessage="No roles created yet."
    (edit)="openEdit($event)"
    (delete)="onDelete($event)"
    (permission)="navigateToPermissions($event)"
    (toggleStatus)="onToggleStatus($event)">
  </app-rbac-table>

  <div class="rbac-page__header">
    <h4>Role Categories</h4>
    <button type="button" class="rbac-btn rbac-btn--primary" (click)="openAddCategory()">+ Add Role Category</button>
  </div>

  <app-rbac-table
    [columns]="categoryColumns"
    [rows]="categories"
    [loading]="categoryLoading"
    emptyMessage="No role categories created yet."
    (edit)="openEditCategory($event)"
    (delete)="onDeleteCategory($event)">
  </app-rbac-table>
</div>

<app-rbac-modal [open]="modalOpen" (closed)="closeModal()">
  <app-rbac-form
    [title]="editingRole ? 'Edit Role' : 'Add Role'"
    [fields]="fields"
    [model]="editingRole"
    [saving]="saving"
    (save)="onSave($event)"
    (cancel)="closeModal()">
  </app-rbac-form>
</app-rbac-modal>

<app-rbac-modal [open]="categoryModalOpen" (closed)="closeCategoryModal()">
  <app-rbac-form
    [title]="editingCategory ? 'Edit Role Category' : 'Add Role Category'"
    [fields]="categoryFields"
    [model]="editingCategory"
    [saving]="categorySaving"
    (save)="onSaveCategory($event)"
    (cancel)="closeCategoryModal()">
  </app-rbac-form>
</app-rbac-modal>